export const getAdvisors = (state) => state.advisor.advisors;
export const getAdvisorStatus = (state) => state.advisor.advisorStatus;
export const getAdvisorPartner = (state) => state.advisor.advisorPartner;
